(function () {
    "use strict";
    angular.module("trakeyeApp").factory("TrRow", TrRow);

    TrRow.$inject = ["$resource", "DateUtils"];

    function TrRow($resource, DateUtils) {
        var resourceUrl = "api/tr-rows/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                },
            }
        );
    }
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrRowById", [
        "$rootScope",
        "$http",
        function ($rootScope, $http) {
            var service = {};
            service.get = function (id, callback) {
                $http.get("api/tr-rows/" + id).then(function (response) {
                    callback(response.data);
                });
            };

            return service;
        },
    ]);
})();

(function () {
    "use strict";

    angular.module("trakeyeApp").factory("TrRowSearch", TrRowSearch);

    TrRowSearch.$inject = ["$resource"];

    function TrRowSearch($resource) {
        var service = $resource(
            "/api/tr-rows/searchvalue/:search",
            {},
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
            }
        );

        return service;
    }
})();

(function () {
	'use strict';

	angular.module('trakeyeApp').factory('AllRowTypes', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
		service.getAll = function (callback) {
			$http.get('api/row-alltypes').then(function (response) {
				callback(response.data);
			});
		};

		return service;
	}]);
})();
